/**
 * Created by Paul on 6/5/2017.
 */
import {Component, Input} from '@angular/core';
import {SixMarkBaseComponent} from "../sixMarkBase";

@Component({
  selector: 'sm-big-small',
  templateUrl: './sixmarkBigSmall.html',
})

/**
 * mname: SM05
 * The game has 4 options: Big, Small, Even and Odd
 */
export class SixMarkBigSmallComponent extends SixMarkBaseComponent{
  // List of bet options. Each has 4 props: title, type, description and betCoins
  betOptions = [];

  @Input()
  set selectOption(selectOption: any) {
    if (selectOption) {
      this.betOptions = selectOption.no.betOptions;
      this.maxAmountPerOption = selectOption.no.maxAmountPerOption;
      this.maxAmountPerBet = selectOption.no.maxAmountPerBet;
      this._selectOption = selectOption;
    }
  }

  /**
   * Get bet option by code
   * @param code: a string indicates the type of bet option
   */
  getBetOptionByCode(code: string) {
    let betOption = this.betOptions.find(option => option.code === code);
    return betOption;
  }

  /**
   * Reset all status to the beginning of the game
   */
  resetGame() {
    // Reset numbers status
    this.resetBetCoins(this.betOptions);

    // Reset total
    this.onTotalChanged.emit(0);
  }

  /**
   * Remove a specific bets based on its code
   * @param bets: an array of betting code
   */
  removeBets(bets = []) {
    bets.forEach(betOptionCode => {
      let betOption = this.getBetOptionByCode(betOptionCode);
      if (betOption) {
        betOption.betCoins.pop();
      }
    });
  }

  /**
   * Get an option by its code
   * @param optionCode
   */
  getOptionByCode(optionCode): any {
    return this.getBetOptionByCode(optionCode);
  }
}



// WEBPACK FOOTER //
// ./src/component/sixmark/bigSmall/sixmarkBigSmall.ts